export default __webpack_public_path__ + "static/media/img-0360-central-african-half-face.15607263.png";